import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Filters from '../containers/filters';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionActions from '@mui/material/AccordionActions';
import Divider from '@mui/material/Divider';
import ChartConfig from '../containers/ChartConfig/chartConfig'
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material';
import ChartSlider from '../containers/Chart/chartSlider';
import ChartTable from '../containers/Chart/ChartTable';

const PREFIX = 'ChartView';

const classes = {
    container: `${PREFIX}-container`,
    filters: `${PREFIX}-filters`,
    buttonContainer: `${PREFIX}-buttonContainer`,
    button: `${PREFIX}-button`,
    labelContainer: `${PREFIX}-labelContainer`,
    iconLabelWrapper: `${PREFIX}-iconLabelWrapper`,
    chartContainer: `${PREFIX}-chartContainer`,
    root: `${PREFIX}-root`,
    heading: `${PREFIX}-heading`,
    secondaryHeading: `${PREFIX}-secondaryHeading`,
    box: `${PREFIX}-box`,
    noChartText: `${PREFIX}-noChartText`,
    filterContainer: `${PREFIX}-filterContainer`
};

/*
[theme.breakpoints.up('lg')]: {
            height: height * 0.60,
        },
        */

const Root = styled('div')(({ theme }) => ({
    [`& .${classes.container}`]: {
        display: 'flex',
        alignContent: 'center',
    },

    [`& .${classes.filters}`]: {
        marginLeft: '10px',
        marginRight: '20px',
        marginTop: '0px',
        marginBottom: '15px',
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        "&:last-child": {
            paddingBottom: 10,
            paddingLeft: 0,
            paddingTop: 0
        }
    },

    [`& .${classes.buttonContainer}`]: {
        display: "flex",
        justifyContent: 'space-evenly',
        marginBottom: '7px',
    },

    [`& .${classes.button}`]: {
        color: 'white'
    },

    [`& .${classes.labelContainer}`]: {
        width: "auto",
        padding: 0
    },

    [`& .${classes.iconLabelWrapper}`]: {
        flexDirection: "row"
    },

    [`& .${classes.chartContainer}`]: {
        marginLeft: '0px',
        marginRight: '0px',
        marginBottom: '0px',
        paddingBottom: '0px',
        paddingLeft: '0px',
        maxHeight: '100%',
        width: '100%'
    },

    [`&.${classes.root}`]: {
        width: '100%',
        /*
        [theme.breakpoints.only('xl')]: {
            backgroundColor: 'cyan',
        },
        [theme.breakpoints.only('lg')]: {
            backgroundColor: 'orange',
        },
        [theme.breakpoints.only('md')]: {
            backgroundColor: 'green',
        },
        [theme.breakpoints.only('sm')]: {
        backgroundColor: 'red',
        },
        [theme.breakpoints.only('xs')]: {
            backgroundColor: 'blue',
        },
        */
    },

    [`& .${classes.heading}`]: {
        fontSize: theme.typography.pxToRem(16), /*adjust the size if the text in the top of the accordions*/
        flexShrink: 0,
    },

    [`& .${classes.secondaryHeading}`]: {
        fontSize: theme.typography.pxToRem(15), /*adjust the size if the text in the top of the accordions*/
        color: theme.palette.text.secondary,
    },

    [`& .${classes.box}`]: {
        margin: 0
    },

    [`& .${classes.noChartText}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },

    [`& .${classes.filterContainer}`]: {
        width: '100%',
    }
}));

function ChartView(props) {
    const {
        height,
        chartConfig,
        setChartConfiguration,
        disabled,
        handleSaveConfiguration,
        handleChangeAccordion,
        chartTitle,
        expanded,
    } = props;



    var chartTitleComponent = null;
    if (chartTitle === "Sin datos para graficar") {
        chartTitleComponent = <Typography style={{ marginLeft: "10px" }} className={classes.secondaryHeading}>{chartTitle}</Typography>
    }
    else {
        chartTitleComponent = <Typography style={{ marginLeft: "10px" }} color="primary">{chartTitle}</Typography>
    }

    const theme = useTheme();
    //screen size checks
    const movileCheck = useMediaQuery(theme.breakpoints.down('lg'));
    const sizeCheck = {
        "xsCheck": useMediaQuery(theme.breakpoints.only('xs')),
        "smCheck": useMediaQuery(theme.breakpoints.only('sm')),
        "mdCheck": useMediaQuery(theme.breakpoints.only('md')),
        "lgCheck": useMediaQuery(theme.breakpoints.only('lg')),
        "xlCheck": useMediaQuery(theme.breakpoints.only('xl'))
    }

    return (
        <Root className={classes.root}>
            <Accordion expanded={expanded === 'chart-configuration'} value='panel1' onChange={handleChangeAccordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1bh-content"
                    id="chart-configuration"
                >
                    <Typography component={'div'} className={classes.heading}>
                        <Box className={classes.box} fontWeight="fontWeightMedium" m={1}>1. Datos necesarios para generar gráficos</Box>
                    </Typography>

                </AccordionSummary>
                <AccordionDetails>
                    <ChartConfig
                        chartConfig={chartConfig}
                        setChartConfiguration={setChartConfiguration}
                    />
                </AccordionDetails>
                <Divider />
                <AccordionActions>
                    {disabled === false ?
                        <Button onClick={() => handleSaveConfiguration(movileCheck)} variant="contained" size="small" color="primary" disableElevation disabled={disabled}>
                            Siguiente
                        </Button>
                        :
                        <Tooltip title="Debes completar los campos requeridos">
                            <span>
                                <Button onClick={() => handleSaveConfiguration(movileCheck)} variant="contained" size="small" color="primary" disableElevation disabled={disabled}>
                                    Siguiente
                                </Button>
                            </span>
                        </Tooltip>

                    }
                </AccordionActions>
            </Accordion>
            {movileCheck === true ?
                <MobileInterfase 
                    {...props}
                    classes={classes}
                    smCheck={movileCheck}
                    sizeCheck={sizeCheck}
                    chartTitleComponent={chartTitleComponent}
                />
                :
                <DesktopInterfase 
                    {...props}
                    classes={classes}
                    smCheck={movileCheck}
                    sizeCheck={sizeCheck}
                    chartTitleComponent={chartTitleComponent}
                />
            }
        </Root>
    );
}

function DesktopInterfase(props){
    const {
        classes,
        smCheck,
        sizeCheck,
        height,
        width,
        expanded,
        chartTitleComponent,
        filters,
        showChart,
        showTable,
        chartData,
        disabledCreateChart,
        handleChangeAccordion,
        handleCreateChart,
        handleCreateTable,
        updateFiltersMessage,
        setRequiredFilters,
        handleExportChart,
        handleBack,
        updateTheNumberOfGeneratedCharts,
        handleExportAllCharts,
        updateSelectedSlide,
        exportAllButtonText,
        exportButtonText,
        exportTableButtonText,
        updateTableData,
        handleExportTable
    } = props;
    const theme = useTheme();
    return(
        <Accordion expanded={expanded === 'chart-view'} onChange={handleChangeAccordion} >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2bh-content"
                id="chart-view"
            >
                <div style={{ display: "flex" }}>
                    <Typography component={'div'} className={classes.heading}>
                        <Box className={classes.box} fontWeight="fontWeightMedium" m={1}>2. Gráfico: </Box>
                    </Typography>
                    {chartTitleComponent}
                </div>
            </AccordionSummary>
            <AccordionDetails>
                {filters.length === 0 ?
                    <Typography variant="body2">Complete los datos necesarios para generar el gráfico en la sección anterior. </Typography>
                    :
                    <Grid container spacing={1} className={classes.container}>
                        <Grid item xs={3} className={classes.filterContainer}>
                            <Card variant="outlined">
                                <CardContent className={classes.filters} sx={theme.breakpoints.up('lg')?({height: height * 0.60}):null}>
                                    <Filters
                                        width={width}
                                        height={height}
                                        chart="Por dia"
                                        filters={filters}
                                        updateFiltersMessage={updateFiltersMessage}
                                        setRequiredFilters={setRequiredFilters}
                                    />
                                </CardContent>
                                <CardActions className={classes.buttonContainer}>
                                    {!disabledCreateChart ?
                                        <Fragment>
                                            <Button color="primary" variant="contained" onClick={() => handleCreateChart(smCheck)} disableElevation disabled={disabledCreateChart}>Generar gráfico</Button>
                                            <Button color="primary" variant="contained" onClick={() => handleCreateTable(smCheck)} disableElevation disabled={disabledCreateChart}>Generar tabla</Button>
                                        </Fragment>
                                        :
                                        <Tooltip title="Debes completar los campos requeridos">
                                            <Fragment>
                                                <Button color="primary" variant="contained" onClick={() => handleCreateChart(smCheck)} disableElevation disabled={disabledCreateChart}>Generar gráfico</Button>
                                                <Button color="primary" variant="contained" onClick={() => handleCreateTable(smCheck)} disableElevation disabled={disabledCreateChart}>Generar tabla</Button>
                                            </Fragment>
                                        </Tooltip>
                                    }
                                </CardActions>
                            </Card>
                        </Grid>
                        {showChart ?
                            <Grid id='chart-image' item xs={9}>
                                {chartData === null ?
                                    null
                                    : chartData.data.length == 0 ?
                                        <div className={classes.noChartText} sx={{height: 0.7 * height}}>
                                            <Typography variant="body2">Sin datos para graficar. Intente con otro(s) filtro(s).</Typography>
                                        </div>
                                        :
                                        <ChartSlider
                                            windowHeight={height}
                                            windowWidth={width}
                                            chartData={chartData}
                                            sizeCheck={sizeCheck}
                                            updateTheNumberOfGeneratedCharts={updateTheNumberOfGeneratedCharts}
                                            updateSelectedSlide={updateSelectedSlide}
                                        />
                                }
                            </Grid> : null}
                        {showTable ?
                            <Grid id='table' item xs={9}>
                                {chartData === null ?
                                    null
                                    : chartData.data.length == 0 ?
                                        <div className={classes.noChartText} sx={{height: 0.7 * height}}>
                                            <Typography variant="body2">Sin datos para desplegar. Intente con otro(s) filtro(s).</Typography>
                                        </div>
                                        :
                                        <ChartTable
                                            windowHeight={height}
                                            chartData={chartData}
                                            updateTableDataChartView={updateTableData}
                                        />
                                }
                            </Grid> : null}
                    </Grid>
                }
            </AccordionDetails>
            <Divider />
            <AccordionActions>
                {showChart ? chartData === null ? null: chartData.data.length==0 ? null: 
                    <Fragment>
                        <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportChart} >{exportButtonText}</Button>
                        <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportAllCharts} >{exportAllButtonText}</Button>
                    </Fragment>
                    : null
                }
                {showTable ? chartData === null ? null: chartData.data.length==0 ? null: 
                    <Fragment>
                        <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportTable} >{exportTableButtonText}</Button>
                    </Fragment>
                    : null
                }
                <Button disableElevation color="primary" size="small" variant="contained" onClick={handleBack} style={{ marginLeft: '20px' }}> Volver</Button>
            </AccordionActions>
        </Accordion>
    );
}

function MobileInterfase(props){
    const {
        classes,
        smCheck,
        sizeCheck,
        height,
        width,
        expanded,
        filters,
        updateFiltersMessage,
        setRequiredFilters,
        disabled,
        disabledCreateChart,
        chartTitleComponent,
        showChart,
        showTable,
        chartData,
        handleCreateChart,
        handleCreateTable,
        handleChangeAccordion,
        handleExportChart,
        handleBack,
        updateTheNumberOfGeneratedCharts,
        handleExportAllCharts,
        updateSelectedSlide,
        exportAllButtonText,
        exportButtonText,
        exportTableButtonText,
        updateTableData,
        handleExportTable
    } = props;

    return(
        <div>
            <Accordion expanded={expanded === 'filter-view'} onChange={handleChangeAccordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="filter-view"
                >
                    <Typography component={'div'} className={classes.heading}>
                        <Box className={classes.box} fontWeight="fontWeightMedium" m={1}>2. Filtros de gráficos</Box>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {filters.length === 0 ?
                        <Typography variant="body2">Complete los datos necesarios en la sección anterior para obtener los filtros del gráfico. </Typography>
                        :
                        <Card variant="outlined" className={classes.filterContainer}>
                            <CardContent className={classes.filters} sx={sizeCheck["lgCheck"]?({height: height * 0.60}):null}>
                                <Filters
                                    width={width}
                                    height={height}
                                    chart="Por dia"
                                    filters={filters}
                                    updateFiltersMessage={updateFiltersMessage}
                                    setRequiredFilters={setRequiredFilters}
                                />
                            </CardContent>
                        </Card>
                    }
                </AccordionDetails>
                <Divider />
                <AccordionActions>
                    {!disabledCreateChart ?
                        <Fragment>
                            <Button color="primary" variant="contained" onClick={() => handleCreateChart(smCheck)} disableElevation disabled={disabledCreateChart}>Generar gráfico</Button>
                            <Button color="primary" variant="contained" onClick={() => handleCreateTable(smCheck)} disableElevation disabled={disabledCreateChart}>Generar tabla</Button>
                        </Fragment>
                        :
                        <Tooltip title="Debes completar los campos requeridos">
                            <Fragment>
                                <Button color="primary" variant="contained" onClick={() => handleCreateChart(smCheck)} disableElevation disabled={disabledCreateChart}>Generar gráfico</Button>
                                <Button color="primary" variant="contained" onClick={() => handleCreateTable(smCheck)} disableElevation disabled={disabledCreateChart}>Generar tabla</Button>
                            </Fragment>
                        </Tooltip>
                    }
                </AccordionActions>
            </Accordion>  
            <Accordion expanded={expanded === 'chart-view'} onChange={handleChangeAccordion}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2bh-content"
                    id="chart-view"
                >
                    <div style={{ display: "flex" }}>
                        <Typography component={'div'} className={classes.heading}>
                            <Box className={classes.box} fontWeight="fontWeightMedium" m={1}>3. Gráfico: </Box>
                        </Typography>
                        {chartTitleComponent}
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    {filters.length === 0 ?
                        <Typography variant="body2">Complete los datos necesarios para generar el gráfico en la sección anterior. </Typography>
                        :
                        <Fragment>
                            {showChart ?
                                <div id='chart-image' className={classes.chartContainer} >
                                    {chartData === null ?
                                        null
                                        : chartData.data.length == 0 ?
                                            <div className={classes.noChartText} sx={{height: 0.7 * height}}>
                                                <Typography variant="body2">Sin datos para graficar. Intente con otro(s) filtro(s).</Typography>
                                            </div>
                                            :
                                            <ChartSlider
                                                windowHeight={height}
                                                windowWidth={width}
                                                chartData={chartData}
                                                sizeCheck={sizeCheck}
                                                updateTheNumberOfGeneratedCharts={updateTheNumberOfGeneratedCharts}
                                                updateSelectedSlide={updateSelectedSlide}
                                            />
                                    }
                                </div> : null
                            }
                            {showTable ?
                                <div id='table' className={classes.chartContainer} >
                                    {chartData === null ?
                                        null
                                        : chartData.data.length == 0 ?
                                            <div className={classes.noChartText} sx={{height: 0.7 * height}}>
                                                <Typography variant="body2">Sin datos para desplegar. Intente con otro(s) filtro(s).</Typography>
                                            </div>
                                            :
                                            <ChartTable
                                                windowHeight={height}
                                                chartData={chartData}
                                                updateTableDataChartView={updateTableData}
                                            />
                                    }
                                </div> : null} 
                        </Fragment>
                    }
                </AccordionDetails>
                <Divider />
                <AccordionActions>
                    {showChart ? chartData === null ? null: chartData.data.length==0 ? null: 
                        <Fragment>
                            <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportChart} >{exportButtonText}</Button>
                            <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportAllCharts} >{exportAllButtonText}</Button>
                        </Fragment>
                        : null
                    }
                    {showTable ? chartData === null ? null: chartData.data.length==0 ? null: 
                        <Fragment>
                            <Button disableElevation color="primary" size="small" variant="outlined" onClick={handleExportTable} >{exportTableButtonText}</Button>
                        </Fragment>
                        : null
                    }
                    <Button disableElevation color="primary" size="small" variant="contained" onClick={handleBack} style={{ marginLeft: '20px' }}> Volver</Button>
                </AccordionActions>
            </Accordion>
        </div>
    );
}

export default ChartView;